import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/translation.json";
import uz from "./locales/uz/translation.json";
import ko from "./locales/ko/translation.json";

const saved = localStorage.getItem("lang");

i18n.use(initReactI18next).init({
  lng: saved || "en",
  fallbackLng: "en",
  supportedLngs: ["en", "uz", "ko"],
  resources: {
    en: { translation: en },
    uz: { translation: uz },
    ko: { translation: ko },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
